import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import Carousel from 'nuka-carousel';
import VisibilitySensor from 'react-visibility-sensor';

const propTypes = {
  className: PropTypes.string,
  autoplay: PropTypes.bool,
  autoplayInterval: PropTypes.number,
  slide: PropTypes.number,
  slideCount: PropTypes.number,
  currentSlide: PropTypes.number,
  slides: PropTypes.array.isRequired,
  slidesToScroll: PropTypes.array,
  wrapAround: PropTypes.bool,
  initialSlideHeight: PropTypes.number,
  children: PropTypes.node,
};

const defaultProps = {
  className: '',
  autoplay: false,
  autoplayInterval: 3000,
  slide: 0,
  slideCount: 0,
  currentSlide: 0,
  slides: [],
  slidesToScroll: [],
  wrapAround: true,
  initialSlideHeight: 634,
  children: null,
};

const getIndexes = (count, inc) => {
  const step = inc && inc > 0 ? inc : 1;
  const arr = [];
  for (let i = 0; i < count; i += step) {
    arr.push(i);
  }
  return arr;
};

const getActiveButton = active => (active ? 'text-color-dark-slate opacity-100' : '');

const SlideProgress = ({ slideCount, slidesToScroll, currentSlide, goToSlide }) => {
  const indexes = getIndexes(slideCount, slidesToScroll);
  return (
    <ul className="list-inline">
      {indexes.map(index => (
        <li className="text-color-slate" key={index}>
          <button
            className={`btn-transparent opacity-50 text-size-24 padding-5 ${getActiveButton(currentSlide === index)}`}
            onClick={() => goToSlide(index)}
          >
            &bull;
          </button>
        </li>
      ))}
    </ul>
  );
};

SlideProgress.propTypes = {
  slideCount: PropTypes.number,
  slidesToScroll: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
  currentSlide: PropTypes.number,
  goToSlide: PropTypes.func,
};

SlideProgress.defaultProps = {
  slideCount: 0,
  slidesToScroll: 1,
  currentSlide: 0,
  goToSlide: () => {},
};

const DECORATORS = [
  {
    component: SlideProgress,
    position: 'BottomCenter',
  },
];

const DotPageCarousel = ({
  autoplayInterval,
  className,
  wrapAround,
  initialSlideHeight,
  children,
}) => {
  const [autoplay, setAutoplay] = useState(false);

  const handleVisibilityChange = useCallback((isVisible) => {
    setAutoplay(isVisible);
  }, []);

  const mergedClassName = `dot-page-carousel ${className}`;

  return (
    <VisibilitySensor onChange={handleVisibilityChange} partialVisibility>
      <Carousel
        className={mergedClassName}
        decorators={DECORATORS}
        wrapAround={wrapAround}
        autoplayInterval={autoplayInterval}
        initialSlideHeight={initialSlideHeight}
        autoplay={autoplay}
      >
        {children}
      </Carousel>
    </VisibilitySensor>
  );
};

DotPageCarousel.propTypes = propTypes;
DotPageCarousel.defaultProps = defaultProps;

export default DotPageCarousel;
